var _path, _path2, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppDeclinedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 2.94922L17 8.94922",
    stroke: "#14142B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2.94922L23 8.94922",
    stroke: "#14142B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.44299,
    cy: 4.6637,
    r: 3.4137,
    stroke: "#14142B",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43949 15.5145C7.73641 15.5145 8.94509 15.3056 9.85723 14.9407C10.3112 14.7591 10.7289 14.5241 11.0454 14.2248C11.3635 13.924 11.629 13.5065 11.629 12.9887C11.629 12.4708 11.3635 12.0534 11.0454 11.7526C10.7289 11.4532 10.3112 11.2182 9.85723 11.0367C8.94509 10.6718 7.73641 10.4629 6.43949 10.4629C5.14257 10.4629 3.93389 10.6718 3.02175 11.0367C2.56777 11.2182 2.15004 11.4532 1.83355 11.7526C1.51547 12.0534 1.25 12.4708 1.25 12.9887C1.25 13.5065 1.51547 13.924 1.83355 14.2248C2.15004 14.5241 2.56777 14.7591 3.02175 14.9407C3.93389 15.3056 5.14257 15.5145 6.43949 15.5145Z",
    stroke: "#14142B",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppDeclinedIcon);
export default __webpack_public_path__ + "static/media/AppDeclinedIcon.e9a2a7c35eb35091c067efc3a470ad8c.svg";
export { ForwardRef as ReactComponent };